// ** React Imports
import { Suspense, lazy } from 'react'
import ReactDOM from 'react-dom' 
 
 // ** Easy-Peasy
import { StoreProvider } from 'easy-peasy'
import { store, database } from './configs/store'

// ** Intl, CASL & ThemeColors Context 
import { ToastContainer } from 'react-toastify' 
import { ThemeContext } from './utility/context/ThemeColors'
import { IntlProviderWrapper } from './utility/context/Internationalization'

// ** Spinner (Splash Screen)
import Spinner from './@core/components/spinner/Fallback-spinner'

// ** Ripple Button
import './@core/components/ripple-button'
  
// ** PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'
import 'prismjs/components/prism-jsx.min'

// ** React Perfect Scrollbar
import 'react-perfect-scrollbar/dist/css/styles.css'

// ** React Toastify
import '@styles/react/libs/toastify/toastify.scss'

// ** Core styles
import './@core/assets/fonts/feather/iconfont.css'
import './@core/scss/core.scss'
import './assets/scss/style.scss'

// ** Service Worker
import * as serviceWorker from './serviceWorker' 

// ** Lazy load app
const LazyApp = lazy(() => import('./App'))
 
ReactDOM.render(
    <StoreProvider store={store}>
      <Suspense fallback={<Spinner />}> 
          <ThemeContext>
            <IntlProviderWrapper>
              <LazyApp />
              <ToastContainer newestOnTop />
            </IntlProviderWrapper>
          </ThemeContext> 
      </Suspense>
    </StoreProvider>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
